import React from "react";
import styles from "./FeedbackFaces.module.css";

export const FACES = [
  { label: "Bad", value: 1 },
  { label: "Average", value: 2 },
  { label: "Good", value: 3 },
  { label: "Excellent", value: 4 },
];

// SVG face renderer for each rating.
const FaceSvg = ({ label }) => {
  switch (label) {
    case "Bad":
      return (
        <svg viewBox="0 0 76 76" aria-hidden="true">
          <g className={styles.faceBad} style={{ transformOrigin: "38px 38px" }}>
            <circle cx="38" cy="38" r="32" fill="none" stroke="#F05252" strokeWidth="4.5" />
            <g className={styles.blink} style={{ transformOrigin: "38px 30px" }}>
              <circle cx="28" cy="30" r="3" fill="#F05252" />
              <circle cx="48" cy="30" r="3" fill="#F05252" />
            </g>
            <path d="M25 52 Q38 43 51 52" fill="none" stroke="#F05252" strokeWidth="3" strokeLinecap="round" />
            <line x1="22" y1="21" x2="31" y2="25" stroke="#F05252" strokeWidth="2" strokeLinecap="round" />
            <line x1="45" y1="25" x2="54" y2="21" stroke="#F05252" strokeWidth="2" strokeLinecap="round" />
          </g>
        </svg>
      );
    case "Average":
      return (
        <svg viewBox="0 0 76 76" aria-hidden="true">
          <g className={styles.faceAvg} style={{ transformOrigin: "38px 38px" }}>
            <circle cx="38" cy="38" r="32" fill="none" stroke="#F6A609" strokeWidth="4.5" />
            <g className={styles.blink} style={{ transformOrigin: "38px 30px", animationDelay: "0.5s" }}>
              <circle cx="28" cy="30" r="3" fill="#F6A609" />
              <circle cx="48" cy="30" r="3" fill="#F6A609" />
            </g>
            <line x1="25" y1="50" x2="51" y2="50" stroke="#F6A609" strokeWidth="3" strokeLinecap="round" />
          </g>
        </svg>
      );
    case "Good":
      return (
        <svg viewBox="0 0 76 76" aria-hidden="true">
          <g className={styles.faceGood} style={{ transformOrigin: "38px 38px" }}>
            <circle cx="38" cy="38" r="32" fill="none" stroke="#7DC95E" strokeWidth="4.5" />
            <g className={styles.blink} style={{ transformOrigin: "38px 30px", animationDelay: "1s" }}>
              <circle cx="28" cy="30" r="3" fill="#7DC95E" />
              <circle cx="48" cy="30" r="3" fill="#7DC95E" />
            </g>
            <path d="M25 47 Q38 57 51 47" fill="none" stroke="#7DC95E" strokeWidth="3" strokeLinecap="round" />
          </g>
        </svg>
      );
    case "Excellent":
      return (
        <svg viewBox="0 0 76 76" aria-hidden="true">
          <g>
            <g transform="translate(10, 13)">
              <g className={`${styles.sparkle} ${styles.sparkle1}`}>
                <path
                  d="M 0,-5.5 L 1.5,-1.5 L 5.5,0 L 1.5,1.5 L 0,5.5 L -1.5,1.5 L -5.5,0 L -1.5,-1.5 Z"
                  fill="#F6A609"
                />
              </g>
            </g>
            <g transform="translate(65, 11)">
              <g className={`${styles.sparkle} ${styles.sparkle2}`}>
                <path d="M 0,-7 L 1.8,-1.8 L 7,0 L 1.8,1.8 L 0,7 L -1.8,1.8 L -7,0 L -1.8,-1.8 Z" fill="#F6A609" />
              </g>
            </g>
            <g transform="translate(38, 5)">
              <g className={`${styles.sparkle} ${styles.sparkle3}`}>
                <path d="M 0,-4 L 1,-1 L 4,0 L 1,1 L 0,4 L -1,1 L -4,0 L -1,-1 Z" fill="#F6A609" />
              </g>
            </g>
          </g>
          <g className={styles.faceExcellent} style={{ transformOrigin: "38px 38px" }}>
            <circle cx={38} cy={38} r={30} fill="none" stroke="#2FAE2F" strokeWidth={5} />
            <g className={styles.blink} style={{ transformOrigin: "38px 30px", animationDelay: "0.3s" }}>
              <circle cx={28} cy={30} r="3.2" fill="#155a15" />
              <circle cx={48} cy={30} r="3.2" fill="#155a15" />
            </g>
            <path d="M23 44 Q38 60 53 44" fill="none" stroke="#155a15" strokeWidth="3.5" strokeLinecap="round" />
          </g>
        </svg>
      );
    default:
      return null;
  }
};
export const FeedbackFaces = ({ value = 0, onChange }) => {
  return (
    <div className={styles.facesRow} role="radiogroup" aria-label="Rate your experience">
      {FACES.map((face) => {
        const isSelected = value === face.value;
        return (
          <button
            key={face.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`${styles.faceCard} ${isSelected ? styles.faceCardSelected : ""}`}
            onClick={() => onChange && onChange(face.value)}
          >
            <FaceSvg label={face.label} />
            <span className={styles.faceLabel}>{face.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FeedbackFaces;
